/* eslint-disable import/extensions */
/* eslint-disable @typescript-eslint/no-var-requires */
import React, { useEffect, useState } from 'react';
// import { usePlayFlag } from './../../components/topicScroll';

import './animation007.less';

import ImgIcon1 from './../../../../../assets/Finance.png';
import ImgIcon2 from './../../../../../assets/service.png';
import ImgIcon3 from './../../../../../assets/Shield.png';
import ImgIcon4 from './../../../../../assets/IT.png';
import { Button, Modal } from 'antd';
import ImgPoint from '../../../../../assets/animation_point.gif';
import useIntersectionObserver from '../../../../../hooks/useIntersectionObserver';

const icons = [ImgIcon1, ImgIcon2, ImgIcon3, ImgIcon4];

interface IAnimation007Item {
  icon: string;
  text: string;
  title: string;
  content: string;
  viewMore?: boolean;
  tip?: string;
}

const bgTemplate = ['#3789FF', '#343194', '#F26927', '#0CA39A'];

const getBG = (feed: number) => bgTemplate[feed % bgTemplate.length];

interface IAnimation007Props {
  items: IAnimation007Item[];
  pic: string;
  onCompleted?: () => void;
}

const Animation007: React.FunctionComponent<IAnimation007Props> = ({
  pic,
  items,
  onCompleted,
}) => {
  // const crrRef = useRef() as React.MutableRefObject<HTMLDivElement>;
  // const playFlag = usePlayFlag(crrRef.current as HTMLElement, '.course-body');
  const { targetRef, isVisible } = useIntersectionObserver({
    threshold: 0.5, // 元素 30% 进入视口时触发
    rootMargin: '-50px', // 根边距缩小 50px（需元素进入视口 50px 后才判定）
  });
  const [play, setPlay] = useState(1);
  const [isModalOpen, setModalOpen] = useState(false);
  const startPlay = (next = 1) => {
    setPlay(next);
    next += 1;
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1200);
    } else {
      onCompleted && onCompleted();
    }
  };

  useEffect(() => {
    if (isVisible) {
      startPlay();
    }
  }, [isVisible]);

  const [show, setShow] = useState(true);

  return (
    <div ref={targetRef} className="animation007 component">
      <div className="animation007-content">
        {items.map((itm: IAnimation007Item, idx: number) => (
          <div
            key={idx}
            className={`animation007-item r${idx + 1} animation ${
              play >= idx + 1 ? 'fade-in' : ''
            }`}
          >
            <div
              className="animation007-header"
              style={{
                backgroundColor: getBG(idx),
              }}
            >
              <div className="text-container">
                <div
                  className="animation007-title"
                  dangerouslySetInnerHTML={{ __html: itm.title }}
                />
                <div
                  className="animation007-text"
                  dangerouslySetInnerHTML={{ __html: itm.text }}
                />
                {itm.viewMore ? (
                  <div className="view-more">
                    <Button
                      className="view-more-btn"
                      onClick={() => {
                        setModalOpen(true);
                        setShow(false);
                      }}
                      type="link"
                    >
                      {itm.tip}
                    </Button>
                    <img
                      className="click-point1"
                      hidden={!show}
                      src={ImgPoint}
                      alt=""
                    />
                  </div>
                ) : null}
              </div>
              <div className="icon">
                <img src={icons[idx]} alt="" />
              </div>
            </div>
            <div
              className="animation007-content"
              dangerouslySetInnerHTML={{ __html: itm.content }}
            />
          </div>
        ))}
      </div>
      <Modal
        width="60%"
        className="animation007-modal"
        title={null}
        footer={null}
        visible={isModalOpen}
        onCancel={() => setModalOpen(false)}
      >
        <img src={require(`../../../../../assets/${pic}`).default} alt="" />
      </Modal>
    </div>
  );
};

export default Animation007;
